import React, { useState, useEffect, useContext } from 'react';
import './styles.css';
import { EnglishLogin, SpanishLogin } from '@BUP/components';
import { Form, Col, Button } from 'antd';
import Logo from '@BUP/assets/Images/bup_logo.png';
// import { ReactComponent as GoogleIcon } from '@BUP/assets/Icons/googleIcon.svg';
import { useAuth } from '@BUP/hooks';
import { LoginLanguageContext } from '@BUP/contexts/LoginLanguageContext';

const LoginPage = () => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [error, setError] = useState(null);
  const { signIn } = useAuth();
  const { setLanguage, selectedEnglishLanguage } = useContext(
    LoginLanguageContext
  );

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    try {
      const { email, password } = values;
      await signIn(email, password);
      form.resetFields();
      setError(null);
    } catch (e) {
      console.log('Login error', e);
      setError(e);
    }
  };

  // const singInWhitGoogle = async (values) => {
  //   try {
  //     await signInProvider('google');
  //     form.resetFields();
  //     setError(null);
  //   } catch (e) {
  //     console.log('singInWhitGoogle error', e);
  //     setError(e);
  //   }
  // };

  return (
    <div className="login-page-container">
      <div className="logo-wrapper">
        <img
          id="bup-logo"
          alt="BraveUp-Logo"
          src={Logo}
          style={{
            width: 300,
            height: 45,
          }}
        />
      </div>
      {selectedEnglishLanguage ? (
        <EnglishLogin
          onFinish={onSubmit}
          error={error}
          form={form}
          languageButtons={[
            <Col className="language-buttons-wrapper" key="englishButton">
              <Button onClick={() => setLanguage('es')}>ES</Button>
            </Col>,
          ]}
        />
      ) : (
        <SpanishLogin
          onFinish={onSubmit}
          error={error}
          form={form}
          languageButtons={[
            <Col className="language-buttons-wrapper" key="spanishButton">
              <Button onClick={() => setLanguage('en')}>EN</Button>
            </Col>,
          ]}
        />
      )}
    </div>
  );
};

export default LoginPage;
